import CustomButton from "@/components/CustomButton";
import { IS_PRODUCTION } from "@/constants/constants";
import { getHouseholdPrintFileName } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useRebalancesPrint } from "@/hooks/useRebalancesPrint";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

export default function PrintRebalancesButton() {
  const { mutateAsync: downloadAsync, error: printErrorMsg } = useRebalancesPrint();
  const {
    household,
    header: { isError },
  } = useAppSelector((state) => state.household);

  const fileName = getHouseholdPrintFileName({
    clientCode: household?.clientCode,
    tabName: "Rebalance History",
  });

  const toastMessages = {
    pending: "Downloading rebalance history..",
    success: "Rebalance history downloaded!",
    error:
      printErrorMsg instanceof AxiosError
        ? printErrorMsg.message
        : "Downloading rebalance history failed",
  };

  if (IS_PRODUCTION || isError) return null;

  return (
    <div>
      <CustomButton
        className="screen:mt-4 print:hidden"
        text={"Print to PDF"}
        onClickHandler={() => {
          toast.promise(
            downloadAsync({
              accountID: household?.externalCode,
              fileName,
            }),
            toastMessages
          );
        }}
      />
    </div>
  );
}
